"use strict";

const { mixin } = require("../../utils");
const SVGListBase = require("./SVGListBase");

class SVGStringListImpl {
  constructor(args, privateData) {
    this._initList(privateData);
  }
}

mixin(SVGStringListImpl.prototype, SVGListBase.prototype);

exports.implementation = SVGStringListImpl;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_jsdom@13.2.0@jsdom/lib/jsdom/living/svg/SVGStringList-impl.js
// module id = Ufvy
// module chunks = 0